import { logoStyles } from "@insite/content-library/Widgets/Basic/Logo";
import { css } from "styled-components";

logoStyles.wrapper = {
    css: css``, // keep image from hitting the navigation
};
